import { ENDPOINTS } from "../../apiConfig";
import { showToast } from "../../../components";
import { getResponseMessage } from "../../../utils";
import axiosRequest from "../universal/axiosService";
import dayjs from "dayjs";

//update code
export const fetchEmployees = async ({
  limit,
  page,
  filters,
  ret,
  sort,
  ref,
  incl,
  useAggregate = false,
}) => {
  try {
    // Make both API calls concurrently using axiosRequest
    const [employeesResponse, totalCountResponse] = await Promise.all([
      axiosRequest({
        method: "GET",
        url: ENDPOINTS.EMPLOYEES.GET_ALL,
        params: {
          coll: "Employee",
          lim: limit,
          pg: page,
          fil: JSON.stringify(filters),
          ret: ret,
          ref: ref,
          incl: incl,
          cache: false,
          sort: JSON.stringify(sort),
          ...(useAggregate ? { useAggregate } : {}),
        },
      }),
      axiosRequest({
        method: "GET",
        url: ENDPOINTS.EMPLOYEES.GET_TOTAL_COUNT,
        params: {
          coll: "Employee",
          fil: JSON.stringify(filters),
        },
      }),
    ]);
    return {
      data: employeesResponse.data,
      totalCount: totalCountResponse.data,
    };
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

export const fetchEmployeeByUiid = async ({ uiid, ret, ref, incl }) => {
  const filters = {
    uiid: { type: "NONE", value: uiid },
  };
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.EMPLOYEES.GET_BY_UIID,
    params: {
      coll: "Employee",
      ref: ref,
      ret: ret,
      incl: incl,
      fil: JSON.stringify(filters),
      cache: false,
    },
  });
};

export const fetchLatestUiid = async (type) => {
  const filters = {
    table: { type: "NONE", value: type },
  };

  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.COUNTER.GETID,
    params: {
      coll: "Counter",
      fil: JSON.stringify(filters),
      ret: "count table",
    },
  });
};

export const addNewEmployee = async (employeeData) => {
  const addUser = employeeData?.addToUser;
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.EMPLOYEES.ADD_NEW,
    data: {
      ...(addUser ? { postActions: ["AddToUser"] } : {}),
      coll: "Employee",
      payload: {
        ...employeeData,
      },
    },
  });
};

export const updateEmployee = async ({
  coll,
  uiid,
  patchId,
  tPath,
  payload,
}) => {
  const params = {
    coll,
    ...(uiid && { uiid }),
    ...(patchId && { patchId }),
    ...(tPath && { tPath }),
  };

  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.EMPLOYEES.UPDATE,
    params,
    data: {
      payload,
    },
  });
};
export const bulkUpdateEmployee = async ({
  coll,
  uiid,
  patchId,
  tPath,
  payload,
}) => {
  const params = {
    coll,
    ...(uiid && { uiid }),
    ...(patchId && { patchId }),
    ...(tPath && { tPath }),
  };

  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.EMPLOYEES.BULKUPDATE,
    params,
    data: {
      payload,
    },
  });
};

export const employeeOverviewApi = async (employeeId) => {
  try {
    const [placements, lca, h1b, documents, timesheets, invoiceKpi, payrolls] =
      await Promise.allSettled([
        axiosRequest({
          method: "GET",
          url: ENDPOINTS.PLACEMENTS.GET_ALL,
          params: {
            coll: "Placement",
            ref:"Client",
            incl:["generalInfo.placementDetails"],
            ret: "uiid clientPlacement jobInfo type payments",
            fil: JSON.stringify({
              employeeId: { type: "NONE", value: employeeId },
            }),
          },
        }),
        axiosRequest({
          method: "GET",
          url: ENDPOINTS.LCA.GET_BY_UIID,
          params: {
            coll: "LCA",
            ret: "uiid number startDate endDate placeOfEmployment employeeId status salaryInfo",
            fil: JSON.stringify({
              employeeId: { type: "NONE", value: employeeId },
            }),
            sort: JSON.stringify({ addedOn: -1 }),
          },
        }),
        axiosRequest({
          method: "GET",
          url: ENDPOINTS.H1B.GET_BY_UIID,
          params: {
            coll: "H1B",
            ret: "receiptNum recordStatus employeeId expiryDate filedOn",
            fil: JSON.stringify({
              employeeId: { type: "NONE", value: employeeId },
            }),
            sort: JSON.stringify({ addedOn: -1 }),
          },
        }),
        axiosRequest({
          method: "GET",
          url: ENDPOINTS.DOCUMENT.GET_ALL,
          params: {
            coll: "Document",
            // ret: "uiid docType docExpiry docStatus title",
            ret: "-file -parent -ref",
            fil: JSON.stringify({
              docType: { type: "IN", value: ["Driving License", "I9"] },
              "parent.employee": { type: "NONE", value: employeeId },
            }),
            sort: JSON.stringify({ addedOn: -1 }),
          },
        }),
        axiosRequest({
          method: "GET",
          url: ENDPOINTS.TIMESHEETS.GET_ALL,
          params: {
            coll: "Timesheet",
            ref: "Invoice Placement",
            incl: ["invoiceNum", "clientPlacement.placement"],
            ret: "uiid employeeId dailyEntries status period",
            fil: JSON.stringify({
              employeeId: { type: "NONE", value: employeeId },
              // "period.month": { type: "IN", value: [new Date().getMonth(),new Date().getMonth() - 1] },
              // "period.month": { type: "IN", value: [new Date().getMonth(),new Date().getMonth() - 4] },
              "period": {
                type: "RANGE",
                value: {
                  from: new Date(new Date().setMonth(new Date().getMonth() - 3)),
                  to: new Date()
                }
              }
            }),
            sort: JSON.stringify({
              "period.from": 1,
            }),
          },
        }),
        axiosRequest({
          method: "GET",
          url: ENDPOINTS.INVOICES.GET_ALL,
          params: {
            coll: "Invoice",
            useAggregate: true,
            fil: JSON.stringify({
              invoices: { type: "AG_STATS", value: [employeeId] },
            }),
          },
        }),
        axiosRequest({
          method: "GET",
          url: ENDPOINTS.PAYROLL.GET_ALL,
          params: {
            coll: "Payroll",
            ret: "uiid amounts status payCycle payDay",
            fil: JSON.stringify({
              employeeId: { type: "NONE", value: employeeId },
              status: { type: "NONE", value: 4 },
              "payCycle.from": {
                type: "GTE",
                value: dayjs.utc().startOf("year"),
              },
            }),
          },
        }),
      ]);
    return {
      placements,
      lca,
      h1b,
      documents,
      timesheets,
      invoiceKpi,
      payrolls,
    };
  } catch (error) {
    throw error;
  }
};
